import type { SelectInputOptionType, SelectInputStateType, SelectInputActionType } from "./types";

function getValidIndex(index: number | undefined, options: SelectInputOptionType<string | number>[]) {
  if (index === undefined || index < 0 || index >= options.length) return 0;
  return index;
}

function getPreviousIndex(index: number | undefined, options: SelectInputOptionType<string | number>[]) {
  if (index === undefined || index <= 0) return options.length - 1;
  return index - 1;
}

function getNextIndex(index: number | undefined, options: SelectInputOptionType<string | number>[]) {
  if (index === undefined || index < 0 || index === options.length - 1) return 0;
  return index + 1;
}

export function getValidSelection(options: SelectInputOptionType<string | number>[], activeIndex?: number, value?: string | number) {
  let selected: typeof options[number] | undefined;
  
  if (value !== undefined) {
    selected = options.find((option) => String(option.value) === String(value));
  }
  if (!selected) {
    const index = getValidIndex(activeIndex, options);
    selected = options[index];
  }

  return selected;
}

export function initializeSelectInputState(initialStateModifiers: {
  options: SelectInputOptionType<string | number>[];
  value?: string | number;
}): SelectInputStateType<string | number> {
  const { options, value } = initialStateModifiers;
  const activeIndex = options.findIndex((option) => option.value === value);

  const initialState = {
    open: false,
    options,
  };
  
  if (value === undefined || activeIndex < 0) return initialState;

  return {
    activeIndex, // hovered item in select dropdown
    selected: options[activeIndex], // selected item in select input
    ...initialState,
  };
}

export const selectInputReducer =
  (options: SelectInputOptionType<string | number>[]) => (prevState: SelectInputStateType<string | number>, action: SelectInputActionType<string | number>) => {
  switch (action.type) {
    case "open":
      return { ...prevState, open: true };
      
    case "close":
      if (prevState.selected) return { ...prevState, open: false, activeIndex: options.indexOf(prevState.selected) };
      return { ...prevState, open: false };

    case "setNextActive":
      return { ...prevState, activeIndex: getNextIndex(prevState.activeIndex, options) };

    case "setPreviousActive":
      return { ...prevState, activeIndex: getPreviousIndex(prevState.activeIndex, options) };

    case "setActive":
      return { ...prevState, activeIndex: getValidIndex(action.payload.index, options) };

    case "select":
      return { ...prevState, selected: action.payload.selected };

    default:
      return { ...prevState };
  }
};

export const isElementVisible = (el: HTMLElement, holder: HTMLElement) => {
  holder = holder || document.body
  const { top, bottom, height } = el.getBoundingClientRect()
  const holderRect = holder.getBoundingClientRect()

  return top <= holderRect.top
    ? holderRect.top - top <= height
    : bottom - holderRect.bottom <= 0
}